import React from 'react';
import { Button, Card, Result, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import UserManagementTab from '../components/user/UserManagementTab';
import { trpc } from '../lib/trpc';
import { PageContainer, PageHeader, DevFilePathBadge } from '../components/common';
import { HelpButton } from '../components/help/HelpButton';

const UserManagementPage: React.FC = () => {
  const navigate = useNavigate();
  const { data: currentUser, isLoading: isUserLoading, error: userError } = trpc.user.getProfile.useQuery();
  const {
    data: company,
    isLoading: isCompanyLoading,
    error: companyError,
  } = trpc.company.getCurrentCompany.useQuery(undefined, {
    enabled: !!currentUser,
  });

  if (isUserLoading || isCompanyLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60vh',
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (userError) {
    return (
      <Result
        status="500"
        title="ユーザー情報を取得できません"
        subTitle={userError.message}
        extra={(
          <Button type="primary" onClick={() => navigate('/app/dashboard')}>
            ダッシュボードへ戻る
          </Button>
        )}
      />
    );
  }

  if (companyError) {
    return (
      <Result
        status="500"
        title="会社情報を取得できません"
        subTitle={companyError.message}
        extra={(
          <Button type="primary" onClick={() => navigate('/app/dashboard')}>
            ダッシュボードへ戻る
          </Button>
        )}
      />
    );
  }

  if (!currentUser) {
    return (
      <Result
        status="403"
        title="アクセスできません"
        subTitle="ユーザー情報が確認できなかったため、ユーザー管理を表示できません。"
        extra={(
          <Button type="primary" onClick={() => navigate('/app/dashboard')}>
            ダッシュボードへ戻る
          </Button>
        )}
      />
    );
  }

  const canManageUsers = currentUser.role === 'admin' || currentUser.role === 'manager';

  if (!canManageUsers) {
    return (
      <Result
        status="403"
        title="アクセス権限がありません"
        subTitle="ユーザー管理を閲覧するには管理者またはマネージャー権限が必要です。"
        extra={(
          <Button type="primary" onClick={() => navigate('/app/dashboard')}>
            ダッシュボードへ戻る
          </Button>
        )}
      />
    );
  }

  return (
    <PageContainer>
      <DevFilePathBadge filePath="client/src/pages/UserManagementPage.tsx" />
      <PageHeader
        title="ユーザー管理"
        subtitle="社内ユーザーの作成と外部協力会社の招待、権限変更、無効化を管理します"
        extra={<HelpButton topicId="user-management-overview" size="middle" position="inline" />}
      />
      <Card>
        <UserManagementTab
          companyId={company?.id}
          currentUserRole={currentUser.role}
          currentUserId={currentUser.id}
        />
      </Card>
    </PageContainer>
  );
};

export default UserManagementPage;
